var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "news-file", style: { height: _vm.height + "px" } },
    [
      _c(
        "div",
        {
          staticClass: "news-file__media",
          on: {
            contextmenu: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.image && _vm.url
            ? _c("img", {
                staticClass: "news-file__image",
                attrs: {
                  src: _vm.url,
                  alt: _vm.attachment.name,
                  draggable: "false",
                },
              })
            : _vm.video && _vm.url
            ? _c("video", {
                ref: "video",
                staticClass: "news-file__video",
                attrs: {
                  src: _vm.url,
                  controls: "",
                  controlsList: "nodownload",
                  disablepictureinpicture: "",
                },
              })
            : _vm.image && _vm.loading
            ? _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              })
            : _c("v-icon", { attrs: { size: "72", color: _vm.icon_color } }, [
                _vm._v(_vm._s(_vm.icon)),
              ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "news-file__row" },
        [
          _c("v-icon", { attrs: { color: _vm.icon_color } }, [
            _vm._v(_vm._s(_vm.icon)),
          ]),
          _c("div", { staticClass: "news-file__info" }, [
            _c("div", { staticClass: "news-file__name" }, [
              _vm._v(_vm._s(_vm.attachment.name)),
            ]),
            _c("div", { staticClass: "news-file__size" }, [
              _vm._v(
                _vm._s(_vm.viewable ? _vm.size : "Vista previa no disponible")
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "news-file__actions" },
            [
              _vm.video && !_vm.url
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        text: "",
                        color: "primary",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.loadPreview },
                    },
                    [_vm._v("Reproducir")]
                  )
                : _vm._e(),
              _vm.pdf
                ? _c(
                    "v-btn",
                    {
                      attrs: { small: "", text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.pdf_open = true
                        },
                      },
                    },
                    [_vm._v("Ver")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.attachment.caption
        ? _c("div", { staticClass: "news-file__caption" }, [
            _vm._v(_vm._s(_vm.attachment.caption)),
          ])
        : _vm._e(),
      _vm.pdf
        ? _c("NewsPdfViewer", {
            attrs: { attachment: _vm.attachment },
            model: {
              value: _vm.pdf_open,
              callback: function ($$v) {
                _vm.pdf_open = $$v
              },
              expression: "pdf_open",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }